import React from 'react';
import Modal from 'react-bootstrap/Modal';

// Services & Helpers
import API from 'API';
import FormHelper from 'helpers/FormHelper';

// Components
import Loader from 'components/common/Loader';

//-----------------------------------------------------------------

class EditLetterTemplateModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};

        this.form = new FormHelper({
            fields: {
                name: {
                    label: 'Name',
                    type: 'text',
                    autoFocus: true
                }
            },
            getValue: (fieldName) => this.getFieldValue(fieldName),
            setValue: (fieldName, value) => this.updateFields({ [fieldName]: value })
        });

        this.fileInputRef = React.createRef();
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: true,
                id: null,
                ...opt
            }, () => this.load());
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async load() {
        const { id } = this.state;
        let template;
        if (id) {
            template = await API.call('letter/get-template/' + id);
        } else {
            template = {
                id: 0,
                name: '',
                fileID: 0
            };
        }

        this.setState({
            template,
            isLoading: false
        });
    }

    getFieldValue(fieldName) {
        return this.state.template ? this.state.template[fieldName] : null;
    }

    updateFields(fields) {
        const template = { ...(this.state.template || {}) };
        for (let k in fields) {
            template[k] = fields[k];
        }
        this.setState({ template });
    }

    async saveAndClose(e) {
        if (e) e.preventDefault();
        this.setState({ isLoading: true });

        const template = this.state.template || {};

        // File (may be null)
        const file = this.fileInputRef.current && this.fileInputRef.current.files && this.fileInputRef.current.files[0];

        // Prepare form-data keys that match controller's SaveParam (LetterTemplate) and File
        const data = {
            'LetterTemplate.ID': template.id,
            'LetterTemplate.Name': template.name,
            'LetterTemplate.FileID': template.fileID
        };

        const resp = await API.postFile('letter/save-template', file, data);
        if (resp && resp.success) {
            this.close();
            this.resolve();
            return;
        } else {
            alert((resp && (resp.content || resp.message)) || 'Error saving template');
        }

        this.setState({ isLoading: false });
    }

    async confirmDelete() {
        const confirm = window.confirm('Are you sure you want to delete this template?');
        if (!confirm) return;
        this.setState({ isLoading: true });
        await API.call('letter/delete-template/' + this.state.template.id);
        this.close();
        this.resolve();
    }

    render() {
        const { isOpen, isLoading, template } = this.state;
        if (!isOpen) return null;

        return (
            <Modal show onHide={() => this.close()} className="edit-letter-template-modal" backdrop="static" keyboard={false}>
                {isLoading ?
                    <Modal.Body><Loader /></Modal.Body> :
                    <form onSubmit={e => this.saveAndClose(e)}>
                        <Modal.Body>

                            <fieldset>

                                {this.form.render(['name'])}

                                {template && template.fileID &&
                                    <div className="form-group">
                                        <label className="form-label">Template file</label>
                                        <a className="btn btn-primary" href={`/api/letter/get-template-file/${template.id}`} target="_blank"> 
                                            Download
                                        </a>
                                    </div>
                                }

                                <div className="form-group">
                                    <label className="form-label">Upload new template file (.docx)</label>
                                    <input type="file" accept=".docx" ref={this.fileInputRef} />
                                </div>

                            </fieldset>

                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={() => this.close()}>
                                Cancel
                            </button>
                            {!!(template && template.id) &&
                                <button type="button" className="btn btn-secondary" onClick={() => this.confirmDelete()}>
                                    Delete
                                </button>
                            }
                            <button type="submit" className="btn btn-primary ms-auto">
                                Save Changes
                            </button>
                        </Modal.Footer>
                    </form>
                }
            </Modal>
        );
    }
}

export default EditLetterTemplateModal;
